export default {
  main: {
    site_id: 33,
    title: "Terminal PRO Demo",
    showBetBuilderSection: true,
    terminalId: 992,
    enableMultipleTicketPay: true,
    isTicketsCheckable: true,
    needAdminForResetPin: false,
    ticketAvailableViewMode: ["card"],
    enableTicketAutoCashoutAmountUpdate: false,
    enableTicketPopupFlow: true,
    isWithdrawal: true,
    enableKeyboardCatching: true,
    enableTicketTimer: true,
    enableThemeToggle: true,
    restrictedAdminPrintableTicketsCount: 5,
    hasDayFilter: true,
    enableHeaderAdminSection: true,
    staffPassword: "0",
    homeMediaSlides: [
      {
        type: "boosted",
        path: "betting/prematch/all/boosted/all/all",
      },
      {
        type: "multiple",
        path: "betting/prematch/all/multiples",
      },
      {
        type: "sport",
        path: "betting/prematch",
      },
    ],
    websitePasswordHash: "d78b3cfeb6232b91c0589ddc70fe61e28dc01ed49364d1db34c78a96f772c4b2",
    logoSize: "extra-huge-with-height",
    termsAndConditions: false,
    showEventTypeFilter: true,
    cashoutCommissionPercent: 4,
    resultPageVirtualsId: [150, 197, 209, 118, 54, 55, 31, 184, 181],
    rfidPinCode: false,
    showTicketAfterPay: 10000,
    popupForTerminalLock: false,
    mandatoryCasinoLogin: false,
    availableLanguages: {
      "@replace": true,
      spa: {
        short: "ES",
        name: "Esp",
        region: "UnitedKingdom",
        order: 2,
      },
      eng: {
        short: "EN",
        name: "Eng",
        region: "UnitedKingdom",
        order: 1,
      },
    },
  },
  lastTicketButtons: [
    {
      name: "Bet tickets",
      type: "betTicket",
      hideOnRestrictMode: false,
    },
    {
      name: "Lottery tickets",
      type: "lotteryTicket",
      hideOnRestrictMode: true,
    },
    {
      name: "Cash-out",
      type: "cashoutTicket",
      hideOnRestrictMode: false,
    }
  ],
  betslip: {
    bookingBetBalanceMaxLimit: 9999999,
    enableBookingBet: true,
  },
  routes: [
    {
      name: 'Betting',
      url: 'betting/prematch/all',
      type: 'sportsBook',
      enabled: true,
      nestedItems: [
        {
          url: 'betting/live/all',
          type: 'live',
          name: 'Live',
          enabled: true,
          icon: 'circle',
        },
        {
          url: 'betting/prematch/all',
          type: 'prematch',
          name: 'Sports',
          enabled: true,
          icon: 'casino-categories-Sportsbook',
        },
        {
          url: 'betting/prematch/outrights',
          name: 'Outrights',
          type: 'outrights',
          enabled: true,
          icon: '',
        },
        {
          url: 'betting/prematch/betBuilder',
          type: 'betBuilder',
          name: 'Bet Builder',
          enabled: true,
          icon: 'bet-builder',
        },
        {
          url: 'betting/prematch/popular',
          type: 'popular',
          name: 'Popular',
          enabled: true,
          icon: 'casino-categories-PopularGames',
        },
        {
          url: 'betting/results',
          name: 'Results',
          type: 'results',
          enabled: true,
          icon: '',
        },
      ],
    },
    {
      name: 'Live Casino',
      url: 'liveCasino',
      type: 'liveCasino',
      enabled: true,
    },
    {
      name: 'Virtual Games',
      url: 'thirdPartyGame/156147',
      type: 'virtualGames',
      enabled: true,
      nestedItems: [
        {
          url: 'thirdPartyGame/156147',
          name: 'Pascal Gaming',
          type: 'pascalGaming',
          enabled: true,
          iframeFullscreen: false,
          gameId: '156147',
          icon: 'casino-categories-PGgames',
          gameWithSecondScreen: false,
          onlyInHeader: false,
        },
      ],
    },
    {
      url: "tickets",
      name: "Tickets",
      enabled: true,
    },
  ],
  defaultTerminalParams: { pid: 18762122, tid: 36556, token: "oKzBHQ==", currency: "COP" },
  sportsbook: {
    // asianViewMarket: {
    //   Soccer: {
    //     live: [
    //       [
    //         {
    //           display_key: "WINNER",
    //           title: "Winner",
    //           side: ["P1", "X", "P2"],
    //         },
    //         {
    //           display_key: "DOUBLE CHANCE",
    //           title: "DOUBLE CHANCE",
    //           side: ["1X", "12", "X2"],
    //         },
    //         {
    //           display_key: "NEXTGOALTOSCORE",
    //           title: "NEXT GOAL TO SCORE",
    //           side: ["Home", "No", "Away"],
    //         },
    //       ],
    //       [
    //         {
    //           display_key: "BOTHTEAMTOSCORE",
    //           title: "Both team to score",
    //           side: ["Yes", "No"],
    //         },
    //         {
    //           display_key: "DRAWNOBET",
    //           title: "DRAW NO BET",
    //           side: ["Home", "Away"],
    //         },
    //         {
    //           display_key: "TOTALS",
    //           market_type: {
    //             "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"],
    //           },
    //           title: "Total Goals 1.5",
    //           side: ["Over", "Under"],
    //           base: 1.5,
    //         },
    //         {
    //           display_key: "TOTALS",
    //           market_type: {
    //             "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"],
    //           },
    //           title: "Total Goals 2.5",
    //           side: ["Over", "Under"],
    //           base: 2.5,
    //         },
    //         {
    //           display_key: "TOTALS",
    //           market_type: {
    //             "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"],
    //           },
    //           title: "Total Goals 3.5",
    //           side: ["Over", "Under"],
    //           base: 3.5,
    //         },
    //         {
    //           display_key: "ODD/EVEN",
    //           market_type: {
    //             "@in": ["EvenOddTotal", "FirstHalfEvenOddTotal", "SecondHalfEvenOddTotal"],
    //           },
    //           title: "Total Goals: Even/Odd",
    //           side: ["Even", "Odd"],
    //         },
    //         {
    //           display_key: "HANDICAP",
    //           market_type: {
    //             "@in": ["AsianHandicap", "HalfTimeAsianHandicap", "2ndHalfAsianHandicap"],
    //           },
    //           title: "Handicap",
    //           side: ["Home", "Away"],
    //           alt_main_order: 1,
    //         },
    //         {
    //           display_key: "CARDSTOTALS",
    //           title: "Yellow Cards: Total",
    //           side: ["Over", "Under"],
    //         },
    //         {
    //           display_key: "TOTALS",
    //           market_type: {
    //             "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"],
    //           },
    //           title: "Total Goals 1.5",
    //           side: ["Over", "Under"],
    //           base: 1.5,
    //         },
    //         {
    //           display_key: "TOTALS",
    //           market_type: {
    //             "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"],
    //           },
    //           title: "Total Goals 2.5",
    //           side: ["Over", "Under"],
    //           base: 2.5,
    //         },
    //         {
    //           display_key: "TOTALS",
    //           market_type: {
    //             "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"],
    //           },
    //           title: "Total Goals 3.5",
    //           side: ["Over", "Under"],
    //           base: 3.5,
    //         },
    //       ],
    //     ],
    //     prematch: [
    //       [
    //         {
    //           display_key: "WINNER",
    //           title: "Winner",
    //           side: ["P1", "X", "P2"],
    //         },
    //         {
    //           display_key: "DOUBLE CHANCE",
    //           title: "DOUBLE CHANCE",
    //           side: ["1X", "12", "X2"],
    //         },
    //         {
    //           display_key: "BOTHTEAMTOSCORE",
    //           title: "Both team to score",
    //           side: ["Yes", "No"],
    //         },
    //       ],
    //       [
    //         {
    //           display_key: "TOTALS",
    //           market_type: {
    //             "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"],
    //           },
    //           title: "Total Goals",
    //           side: ["Over", "Under"],
    //           alt_main_order: 1,
    //         },
    //         {
    //           display_key: "TOTALS",
    //           market_type: {
    //             "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"],
    //           },
    //           title: "Total Goals 1.5",
    //           side: ["Over", "Under"],
    //           base: 1.5,
    //         },
    //         {
    //           display_key: "TOTALS",
    //           market_type: {
    //             "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"],
    //           },
    //           title: "Total Goals 2.5",
    //           side: ["Over", "Under"],
    //           base: 2.5,
    //         },
    //         {
    //           display_key: "TOTALS",
    //           market_type: {
    //             "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"],
    //           },
    //           title: "Total Goals 3.5",
    //           side: ["Over", "Under"],
    //           base: 3.5,
    //         },
    //         {
    //           display_key: "HANDICAP",
    //           market_type: {
    //             "@in": ["AsianHandicap", "HalfTimeAsianHandicap", "2ndHalfAsianHandicap"],
    //           },
    //           title: "Handicap",
    //           side: ["Home", "Away"],
    //           alt_main_order: 1,
    //         },
    //       ],
    //     ],
    //   },
    //   Tennis: {
    //     live: [
    //       [
    //         {
    //           display_key: "WINNER",
    //           title: "Winner",
    //           side: ["P1", "P2"],
    //         },
    //         {
    //           market_type: "SetHandicap",
    //           title: "Set Handicap",
    //           side: ["Home", "Away"],
    //         },
    //       ],
    //       [
    //         {
    //           display_key: "TOTALS",
    //           market_type: {
    //             "@in": ["SetOverUnder", "TotalGamesOver/Under"],
    //           },
    //           title: "TOTAL GAMES",
    //           side: ["Over", "Under"],
    //         },
    //         {
    //           market_type: {
    //             "@in": ["TotalGamesOddorEven", "SetTotalGamesOddEven"],
    //           },
    //           title: "TOTAL GAMES ODD OR EVEN",
    //           side: ["Even", "Odd"],
    //         },
    //       ],
    //     ],
    //     prematch: [
    //       [
    //         {
    //           display_key: "WINNER",
    //           title: "Winner",
    //           side: ["P1", "P2"],
    //         },
    //         {
    //           market_type: "SetHandicap",
    //           title: "Set Handicap",
    //           side: ["Home", "Away"],
    //         },
    //       ],
    //       [
    //         {
    //           display_key: "TOTALS",
    //           market_type: {
    //             "@in": ["SetOverUnder", "TotalGamesOver/Under"],
    //           },
    //           title: "TOTAL GAMES",
    //           side: ["Over", "Under"],
    //         },
    //         {
    //           market_type: {
    //             "@in": ["TotalGamesOddorEven", "SetTotalGamesOddEven"],
    //           },
    //           title: "TOTAL GAMES ODD OR EVEN",
    //           side: ["Even", "Odd"],
    //         },
    //       ],
    //     ],
    //   },
    //   Basketball: {
    //     live: [
    //       [
    //         {
    //           title: "Overtime",
    //           market_type: "Overtime",
    //           side: ["Yes", "No"],
    //         },
    //         {
    //           display_key: "HANDICAP",
    //           title: "Match Handicap",
    //           side: ["Home", "Away"],
    //         },
    //       ],
    //       [
    //         {
    //           display_key: "TOTALS",
    //           title: "Match Total",
    //           side: ["Over", "Under"],
    //         },
    //         {
    //           display_key: "ODD/EVEN",
    //           title: "Match Total Odd/Even",
    //           side: ["Even", "Odd"],
    //         },
    //       ],
    //     ],
    //     prematch: [
    //       [
    //         {
    //           display_key: "WINNER",
    //           title: "Winner 2 Way",
    //           col_count: 2,
    //           side: ["P1", "P2"],
    //         },
    //       ],
    //       [
    //         {
    //           display_key: "HANDICAP",
    //           title: "Match Handicap",
    //           side: ["Home", "Away"],
    //         },
    //         {
    //           display_key: "TOTALS",
    //           title: "Match Total",
    //           side: ["Over", "Under"],
    //         },
    //         {
    //           display_key: "ODD/EVEN",
    //           title: "Match Total Odd/Even",
    //           side: ["Even", "Odd"],
    //         },
    //       ],
    //     ],
    //   },
    //   Volleyball: {
    //     live: [
    //       [
    //         {
    //           display_key: "WINNER",
    //           title: "Winner",
    //           side: ["P1", "P2"],
    //         },
    //         {
    //           market_type: "HANDICAP",
    //           title: "Match points Handicap",
    //           side: ["Home", "Away"],
    //         },
    //         {
    //           market_type: "TOTALS",
    //           title: "Total points",
    //           side: ["Home", "Away"],
    //         },
    //       ],
    //       [
    //         {
    //           market_type: {
    //             "@in": ["MatchHandicap2", "PeriodHandicap2"],
    //           },
    //           display_key: "HANDICAP",
    //           title: "Handicap (Regular Time)",
    //           side: ["Home", "Away"],
    //         },
    //       ],
    //     ],
    //     prematch: [
    //       [
    //         {
    //           display_key: "WINNER",
    //           title: "Winner",
    //           side: ["P1", "P2"],
    //         },
    //         {
    //           market_type: "HANDICAP",
    //           title: "Match points Handicap",
    //           side: ["Home", "Away"],
    //         },
    //         {
    //           market_type: "TOTALS",
    //           title: "Total points",
    //           side: ["Home", "Away"],
    //         },
    //       ],
    //       [
    //         {
    //           market_type: {
    //             "@in": ["MatchHandicap2", "PeriodHandicap2"],
    //           },
    //           display_key: "HANDICAP",
    //           title: "Handicap (Regular Time)",
    //           side: ["Home", "Away"],
    //         },
    //       ],
    //     ],
    //   },
    //   Pesapallo: {
    //     live: [
    //       [
    //         {
    //           display_key: "WINNER",
    //           title: "Winner",
    //           side: ["P1", "X", "P2"],
    //         },
    //       ],
    //       [
    //         {
    //           display_key: "TOTALS",
    //           title: "TOTALS",
    //           side: ["Over", "Under"],
    //         },
    //       ],
    //     ],
    //     prematch: [
    //       [
    //         {
    //           display_key: "WINNER",
    //           title: "Winner",
    //           col_count: 3,
    //           side: ["P1", "X", "P2"],
    //         },
    //       ],
    //       [
    //         {
    //           display_key: "TOTALS",
    //           title: "TOTALS",
    //           side: ["Over", "Under"],
    //         },
    //       ],
    //     ],
    //   },
    //   Handball: {
    //     live: [
    //       [
    //         {
    //           display_key: "WINNER",
    //           title: "Winner",
    //           side: ["P1", "X", "P2"],
    //         },
    //       ],
    //       [
    //         {
    //           display_key: "TOTALS",
    //           title: "Total Goals",
    //           side: ["Over", "Under"],
    //         },
    //         {
    //           display_key: "HANDICAP",
    //           title: "Handicap",
    //           side: ["Home", "Away"],
    //           alt_main_order: 1,
    //         },
    //       ],
    //     ],
    //     prematch: [
    //       [
    //         {
    //           display_key: "WINNER",
    //           title: "Winner",
    //           col_count: 3,
    //           side: ["P1", "X", "P2"],
    //         },
    //       ],
    //       [
    //         {
    //           display_key: "TOTALS",
    //           title: "Total Goals",
    //           side: ["Over", "Under"],
    //         },
    //         {
    //           display_key: "HANDICAP",
    //           title: "Handicap",
    //           side: ["Home", "Away"],
    //           alt_main_order: 1,
    //         },
    //         {
    //           display_key: "WINNER",
    //           title: "Match Result",
    //           col_count: 2,
    //           side: ["P1", "P2"],
    //         },
    //       ],
    //     ],
    //   },
    //   BallHockey: {
    //     live: [
    //       [
    //         {
    //           display_key: "WINNER",
    //           title: "Match Result",
    //           side: ["P1", "X", "P2"],
    //         },
    //       ],
    //       [
    //         {
    //           display_key: "TOTALS",
    //           title: "Total Goals",
    //           side: ["Over", "Under"],
    //         },
    //       ],
    //     ],
    //     prematch: [
    //       [
    //         {
    //           display_key: "WINNER",
    //           title: "Match Result",
    //           col_count: 3,
    //           side: ["P1", "X", "P2"],
    //         },
    //       ],
    //       [
    //         {
    //           display_key: "TOTALS",
    //           title: "Total Goals",
    //           side: ["Over", "Under"],
    //         },
    //       ],
    //     ],
    //   },
    //   Futsal: {
    //     live: [
    //       [
    //         {
    //           display_key: "WINNER",
    //           title: "Winner",
    //           side: ["P1", "X", "P2"],
    //         },
    //       ],
    //       [
    //         {
    //           display_key: "TOTALS",
    //           title: "Total Goals",
    //           side: ["Over", "Under"],
    //         },
    //         {
    //           display_key: "HANDICAP",
    //           title: "Handicap",
    //           side: ["Home", "Away"],
    //           alt_main_order: 1,
    //         },
    //       ],
    //     ],
    //     prematch: [
    //       [
    //         {
    //           display_key: "WINNER",
    //           title: "Winner",
    //           col_count: 3,
    //           side: ["P1", "X", "P2"],
    //         },
    //       ],
    //       [
    //         {
    //           display_key: "TOTALS",
    //           title: "Total Goals",
    //           side: ["Over", "Under"],
    //         },
    //         {
    //           display_key: "HANDICAP",
    //           title: "Handicap",
    //           side: ["Home", "Away"],
    //           alt_main_order: 1,
    //         },
    //         {
    //           display_key: "WINNER",
    //           title: "Match Result",
    //           col_count: 2,
    //           side: ["P1", "P2"],
    //         },
    //       ],
    //     ],
    //   },
    //   RugbyLeague: {
    //     live: [
    //       [
    //         {
    //           display_key: "WINNER",
    //           title: "Winner",
    //           side: ["P1", "X", "P2"],
    //         },
    //       ],
    //       [
    //         {
    //           display_key: "TOTALS",
    //           title: "Total Goals",
    //           side: ["Over", "Under"],
    //         },
    //         {
    //           display_key: "HANDICAP",
    //           title: "Handicap",
    //           side: ["Home", "Away"],
    //           alt_main_order: 1,
    //         },
    //       ],
    //     ],
    //     prematch: [
    //       [
    //         {
    //           display_key: "WINNER",
    //           title: "Winner",
    //           col_count: 3,
    //           side: ["P1", "X", "P2"],
    //         },
    //       ],
    //       [
    //         {
    //           display_key: "TOTALS",
    //           title: "Total Goals",
    //           side: ["Over", "Under"],
    //         },
    //         {
    //           display_key: "HANDICAP",
    //           title: "Handicap",
    //           side: ["Home", "Away"],
    //           alt_main_order: 1,
    //         },
    //         {
    //           display_key: "WINNER",
    //           title: "Match Result",
    //           col_count: 2,
    //           side: ["P1", "P2"],
    //         },
    //       ],
    //     ],
    //   },
    //   RugbyUnion: {
    //     live: [
    //       [
    //         {
    //           display_key: "WINNER",
    //           title: "Winner",
    //           side: ["P1", "X", "P2"],
    //         },
    //       ],
    //       [
    //         {
    //           display_key: "TOTALS",
    //           title: "Total Goals",
    //           side: ["Over", "Under"],
    //         },
    //         {
    //           display_key: "HANDICAP",
    //           title: "Handicap",
    //           side: ["Home", "Away"],
    //           alt_main_order: 1,
    //         },
    //       ],
    //     ],
    //     prematch: [
    //       [
    //         {
    //           display_key: "WINNER",
    //           title: "Winner",
    //           col_count: 3,
    //           side: ["P1", "X", "P2"],
    //         },
    //       ],
    //       [
    //         {
    //           display_key: "TOTALS",
    //           title: "Total Goals",
    //           side: ["Over", "Under"],
    //         },
    //         {
    //           display_key: "HANDICAP",
    //           title: "Handicap",
    //           side: ["Home", "Away"],
    //           alt_main_order: 1,
    //         },
    //         {
    //           display_key: "WINNER",
    //           title: "Match Result",
    //           col_count: 2,
    //           side: ["P1", "P2"],
    //         },
    //       ],
    //     ],
    //   },
    //   WaterPolo: {
    //     live: [
    //       [
    //         {
    //           display_key: "WINNER",
    //           title: "Winner",
    //           side: ["P1", "X", "P2"],
    //         },
    //       ],
    //       [
    //         {
    //           display_key: "HANDICAP",
    //           title: "Handicap",
    //           side: ["Home", "Away"],
    //         },
    //       ],
    //     ],
    //     prematch: [
    //       [
    //         {
    //           display_key: "WINNER",
    //           title: "Winner",
    //           col_count: 3,
    //           side: ["P1", "X", "P2"],
    //         },
    //       ],
    //       [
    //         {
    //           display_key: "HANDICAP",
    //           title: "Handicap",
    //           side: ["Home", "Away"],
    //         },
    //       ],
    //     ],
    //   },
    //   Darts: {
    //     live: [
    //       [
    //         {
    //           display_key: "WINNER",
    //           title: "Winner",
    //           col_count: 2,
    //           side: ["P1", "P2"],
    //         },
    //       ],
    //       [
    //         {
    //           display_key: "TOTALS",
    //           market_type: "TotalSetsOver/Under",
    //           title: "TOTAL SETS",
    //           side: ["Over", "Under"],
    //         },
    //       ],
    //     ],
    //     prematch: [
    //       [
    //         {
    //           display_key: "WINNER",
    //           title: "Winner",
    //           col_count: 2,
    //           side: ["P1", "P2"],
    //         },
    //       ],
    //       [
    //         {
    //           display_key: "TOTALS",
    //           market_type: "TotalSetsOver/Under",
    //           title: "TOTAL SETS",
    //           side: ["Over", "Under"],
    //         },
    //       ],
    //     ],
    //   },
    //   Chess: {
    //     live: [
    //       [
    //         {
    //           display_key: "WINNER",
    //           title: "Winner",
    //           side: ["P1", "X", "P2"],
    //         },
    //       ],
    //       [
    //         {
    //           display_key: "TOTALS",
    //           title: "TOTALS",
    //           side: ["Over", "Under"],
    //         },
    //       ],
    //     ],
    //     prematch: [
    //       [
    //         {
    //           display_key: "WINNER",
    //           title: "Winner",
    //           col_count: 3,
    //           side: ["P1", "X", "P2"],
    //         },
    //       ],
    //       [
    //         {
    //           display_key: "TOTALS",
    //           title: "TOTALS",
    //           side: ["Over", "Under"],
    //         },
    //       ],
    //     ],
    //   },
    //   default: {
    //     live: [
    //       [
    //         {
    //           display_key: "WINNER",
    //           title: "Winner",
    //           // col_count: 2,
    //           side: ["P1", "P2"],
    //         },
    //       ],
    //       [
    //         {
    //           display_key: "TOTALS",
    //           title: "TOTALS",
    //           side: ["Over", "Under"],
    //         },
    //       ],
    //     ],
    //     prematch: [
    //       [
    //         {
    //           display_key: "WINNER",
    //           title: "Winner",
    //           col_count: 2,
    //           side: ["P1", "P2"],
    //         },
    //       ],
    //       [
    //         {
    //           display_key: "TOTALS",
    //           title: "TOTALS",
    //           side: ["Over", "Under"],
    //         },
    //       ],
    //     ],
    //   },
    // },
  },
};
